import * as types from '@/store/insights/actionTypes';
import {
  CLEAR_INSIGHTS, SET_INSIGHTS, SET_INSIGHTS_LOADING, SET_ASSET_CORRELATION, CLEAR_ASSET_CORRELATION,
} from '@/store/insights/mutationTypes';
// eslint-disable-next-line import/no-cycle
import {
  getInsightsDetails,
} from '@/services/repository';

export default {
  async [types.LOAD_INSIGHTS]({ commit, state }, options) {
    const previousInsights = state.insights;
    commit(SET_INSIGHTS_LOADING, true);
    commit(CLEAR_INSIGHTS);
    commit(CLEAR_ASSET_CORRELATION);
    try {
      const response = await getInsightsDetails(options.tlds);
      const insights = response.insights || response;

      const assetCorrelation = {};
      Object.keys(insights).forEach(tld => {
        const insightsData = insights[tld]?.data?.insights?.insightsData;
        if (insightsData?.assetCorrelation) {
          assetCorrelation[tld] = insightsData.assetCorrelation;
        }
      });

      // Skip re-render if data is identical to previous fetch
      const hasChanged = JSON.stringify(insights) !== JSON.stringify(previousInsights);
      if (hasChanged) {
        commit(SET_INSIGHTS, insights);
        commit(SET_ASSET_CORRELATION, assetCorrelation);
      }
    } catch (e) {
      commit(CLEAR_INSIGHTS);
      commit(CLEAR_ASSET_CORRELATION);
      throw e;
    } finally {
      commit(SET_INSIGHTS_LOADING, false);
    }
  },
};
